import { render } from "./BlingramPage.vue?vue&type=template&id=9d89a13e"
import script from "./BlingramPage.vue?vue&type=script&lang=js"
export * from "./BlingramPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__